import classNames from 'classnames';
import React, { useState } from 'react';
import * as styles from './SettingsContainerView.module.scss';
import SettingsSidebar from './SettingsSidebar';
import Button from '../components/Button';
import Caret from '../components/Caret';
import IconButton from '../components/IconButton';
import closeIcon from '../icons/non-prefilled/16x16/clear.svg';
import { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';
import Link from '../utils/router/Link';
import useMainContentHistory from '../utils/router/useMainContentHistory';

interface SettingsContainerViewProps {
  className?: string;
  title: React.ReactNode;
  titleRight?: React.ReactNode;
  parentTitle?: string;
  parentLink?: string;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
}

const SettingsContainerView = ({
  className,
  title,
  titleRight,
  parentTitle,
  parentLink,
  subtitle,
  children,
}: SettingsContainerViewProps) => {
  const [isMenuActive, setMenuActive] = useState(false);
  const isMobile = useIsSize(Sizes.SM);
  const mainContentHistory = useMainContentHistory();

  const onClose = () => {
    mainContentHistory.back();
  };

  const header = (
    <>
      Settings: <span className={styles.title}>{parentTitle || title}</span>
      <div className={styles.menuCaret}>
        <Caret direction={isMenuActive ? 'up' : 'down'} />
      </div>
    </>
  );

  return (
    <div
      className={classNames(className, styles.container, {
        [styles.menuActive]: isMenuActive,
      })}
    >
      <div className={styles.topbar}>
        <div className={styles.topbarContent}>
          {isMobile ? (
            <Button onClick={() => setMenuActive(!isMenuActive)}>
              {header}
            </Button>
          ) : (
            header
          )}
          {(isMobile && isMenuActive) || (
            <div className={styles.close}>
              <IconButton
                onClick={onClose}
                applyNegativeMargin
                aria-label="Close"
              >
                {closeIcon}
              </IconButton>
            </div>
          )}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.sidebarContainer}>
          <SettingsSidebar />
        </div>
        <div className={styles.settingsContainer}>
          <div className={styles.settings}>
            <header>
              {parentTitle && parentLink && (
                <div className={styles.breadcrumb}>
                  <Link to={parentLink}>{parentTitle}</Link>
                  <span className={styles.caret}>
                    <Caret inline direction="right" size={6} />
                  </span>
                </div>
              )}
              {typeof title === 'string' ? (
                <div className={styles.settingsTitle}>
                  <h2>{title}</h2>
                  {titleRight}
                </div>
              ) : (
                title
              )}
              {!!subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            </header>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsContainerView;
